import { SET_FIELD_VALUE } from "../constants/fileConstant";

export const setFieldValue = (key, value) => ({
  type: SET_FIELD_VALUE ,
  payload: { key, value  },
});